import { SessionProvider } from 'contexts/session-context'
import { ClientProvider } from 'contexts/client-num-context'
import TriviaProvider from 'contexts/trivia-context'
import { SocialProvider } from 'contexts/social-context'
import { EventsProvider } from 'contexts/events-context'
import { SurveyProvider } from 'contexts/survey-context/survey.provider'
import { MainProvider } from 'contexts/main-class-context'
import { GeneralProvider } from 'contexts/general-context'
import { GroupsProvider } from 'contexts/groups-context'

function AppProviders({ children }: { children: React.ReactNode }) {
  return (
    <SessionProvider>
      <GeneralProvider>
        <GroupsProvider>
          <ClientProvider>
            <EventsProvider>
              <TriviaProvider>
                <SocialProvider>
                  <SurveyProvider>
                    <MainProvider>{children}</MainProvider>
                  </SurveyProvider>
                </SocialProvider>
              </TriviaProvider>
            </EventsProvider>
          </ClientProvider>
        </GroupsProvider>
      </GeneralProvider>
    </SessionProvider>
  )
}

export default AppProviders
